import TabBar from './component'

export default TabBar